import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { LocaleProvider } from "./i18n";
import { InputProvider } from "./components/inputs/InputProvider";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "./styles.css";
import "./styles/design-tokens.css";
import "./styles/workspace-experience.css";
import "./styles/entry-experience.css";
import "./styles/event-experience.css";
import "./styles/event-forms.css";
import "./styles/event-workbench.css";
import "./styles/event-readiness.css";
import "./styles/inputs.css";
import "./styles/admin-consistency.css";
import "./styles/workspace-navigation.css";
import "./styles/scroll-tabs.css";
import "./styles/event-step-layout.css";
import "./styles/event-scope.css";
import "./styles/event-wizard.css";
import "./styles/product-journey.css";
import "./styles/event-setup-layout.css";
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <LocaleProvider>
        <InputProvider><App /></InputProvider>
      </LocaleProvider>
    </BrowserRouter>
  </StrictMode>,
);
